import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { setRateLimit } from '../store/slices/tradingSlice';

import './RateLimitSnackbar.css';

const RateLimitSnackbar: React.FC = () => {
  const rateLimitUntil = useSelector((s: RootState) => s.trading.rateLimitUntil ?? null);
  const dispatch = useDispatch();
  const [remaining, setRemaining] = useState<number>(0);
  // Local dismissed flag: when user dismisses snackbar, hide until next active rate-limit
  const [dismissed, setDismissed] = useState<boolean>(false);

  useEffect(() => {
    if (!rateLimitUntil) {
      setRemaining(0);
      return;
    }

    const tick = () => setRemaining(Math.max(0, rateLimitUntil - Date.now()));
    tick();
    const timer = setInterval(tick, 250);
    return () => clearInterval(timer);
  }, [rateLimitUntil]);

  // Reset dismissed when a new active rate-limit appears
  React.useEffect(() => {
    if (rateLimitUntil && rateLimitUntil > Date.now()) {
      setDismissed(false);
    }
  }, [rateLimitUntil]);

  const isActive = Boolean(rateLimitUntil && rateLimitUntil > Date.now());
  const seconds = Math.ceil(Math.max(0, remaining) / 1000);

  // Показываем snackbar ТОЛЬКО когда есть активный rate-limit (и он не был закрыт пользователем)
  if (!isActive) return null;
  if (dismissed) return null;

  return (
    <div className="rate-snackbar" role="status" aria-live="polite">
      <div className="rate-snackbar__card" data-active={isActive ? '1' : '0'}>
        <div className="rate-snackbar__icon">{isActive ? '⏳' : '✅'}</div>
        <div className="rate-snackbar__body">
          <div className="rate-snackbar__title">{isActive ? 'Please try again later' : 'Service status'}</div>
          <div className="rate-snackbar__message">
            {isActive ? `Rate limit — try again in ${seconds}s` : 'All systems operational'}
          </div>
        </div>
        <button
          className="rate-snackbar__close"
          aria-label="Dismiss"
          onClick={() => { dispatch(setRateLimit(null)); setDismissed(true); }}
        >✕</button>
      </div>
    </div>
  );
};

export default RateLimitSnackbar;
